export const generateButtonHtml = color => ({
  __html: `
    <!--[if mso]>
      <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="?ssId=%NA%" style="height:40px;v-text-anchor:middle;width:300px;" arcsize="10%" stroke="f" fillcolor="#${color}">
        <w:anchorlock/>
          <center style="color:white;font-family:sans-serif;font-size:16px;font-weight:bold;">
            View Analysis
          </center>
      </v:roundrect>
    <![endif]-->
    <![if !mso]>
      <table style="margin: 0 auto;" cellspacing="0" cellpadding="0"> <tr>
        <td align="center" width="300" height="40" bgcolor="#${color}" style="-webkit-border-radius: 5px; white-space: initial; -moz-border-radius: 5px; border-radius: 5px; color: #8C4845; display: block;">
          <a href="?ssId=%NA%" class="do-not-click" style="font-size:16px; font-weight: bold; font-family:sans-serif; text-decoration: none; line-height:40px; width:100%; display:inline-block">
            <span style="color: white;">
              View Analysis
            </span>
          </a>
        </td>
      </tr> </table>
    <![endif]>
  `
});
